// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mailheader-label{text-align:end;color:#787e87;padding-right:.5em}", ""]);
// Exports
module.exports = exports;
